<script setup lang="ts">
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import { Filters } from "~/core/models/filters";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

const props = defineProps<
  GenericParameters & {
    fetchReceivedDelegationResponse?: UseFetchResponse<RelationEntity>;
  }
>();

const searchQuery = computed({
  get() {
    return (props.fetchReceivedDelegationResponse?.filters.get(
      Filters.ORGANIZATION_NAME,
    ) ?? "") as string;
  },
  set(searchQuery) {
    props.fetchReceivedDelegationResponse?.setFilter(
      Filters.ORGANIZATION_NAME,
      searchQuery,
    );
  },
});
</script>

<template>
  <div class="w-full flex flex-col gap-4">
    <search-bar
      v-model:search-query="searchQuery"
      :search-placeholder="$t(`filters.searchByName`)"
      @clear="props.fetchReceivedDelegationResponse?.search"
      @search="props.fetchReceivedDelegationResponse?.search"
    />

    <relation-entity-list
      from-to="from"
      :pagination="
        props.fetchReceivedDelegationResponse?.results?.value?.pagination
      "
      :relations="
        props.fetchReceivedDelegationResponse?.results?.value?.results
      "
      :is-loading="props.fetchReceivedDelegationResponse?.isLoading.value"
      :error="props.fetchReceivedDelegationResponse?.error.value"
      @change-page-and-page-size="
        props.fetchReceivedDelegationResponse?.fetchData
      "
    />
  </div>
</template>
